/* eslint-disable react-hooks/exhaustive-deps */
import { IonContent, IonPage, IonButton } from '@ionic/react'
import React, { useState, useEffect } from 'react'
import QuestionSection from './components/QuestionSection'
import './index.css'
import { useHistory } from 'react-router'
import {
    IdentityQuestionItem,
    mergeIdentityQuestionToKnowledge,
} from '../../service/api/knowledge'
import KnowledgeSearch from './components/KnowledgeSearch'
import TopNList from './components/TopNList'
import { useDebounce } from '../../hooks'
import { useSelector } from 'react-redux'
import { ReduxStore } from '../../redux/reducers'
import { UserModel } from '../../model/user.model'
import {
    getKnowledgesByTitle,
    SearchedKnowledgeModel,
} from '../../service/api/knowledge'
import KnowledgeList from './components/KnowledgesPanel'
import Toast, { ToastProps } from '../../components/Toast'
import Header from '../../components/Header'
const makeEmptyQuestion = (): SearchedKnowledgeModel => {
    return {
        k_id: 0,
        k_title: '',
    }
}
const CombineKnowledge: React.FC = () => {
    const history = useHistory<{ question: IdentityQuestionItem }>()
    const state = history.location.state
    const [question, setQuestion] = useState<IdentityQuestionItem>({
        questionId: 0,
        userQuestion: '',
        topNList: [],
    })
    const [searchedKnowledge, setSearchedKnowledge] = useState(
        makeEmptyQuestion()
    )
    const [topnListShow, setTopnListShow] = useState(true)
    const debounceSearch = useDebounce(searchedKnowledge)
    const userInfo = useSelector<ReduxStore, UserModel>(
        (store) => store.userInfo as UserModel
    )
    const [searchedEmpty, setSearchedEmpty] = useState(false)
    const [searchedKnowledges, setSearchedKnowledges] = useState<
        SearchedKnowledgeModel[]
    >([])
    const [toastOptions, setToastToastOptions] = useState<ToastProps>({
        isOpen: false,
        message: '',
        color: 'error',
        duration: 1000,
    })
    useEffect(() => {
        if (!searchedKnowledge.k_id) {
            handleKnowledgeSearch()
        }
    }, [debounceSearch])
    useEffect(() => {
        if (searchedKnowledge.k_id) {
            setSearchedKnowledges([])
        }
        if (searchedKnowledge.k_title) {
            setTopnListShow(false)
        }
    }, [searchedKnowledge])
    useEffect(() => {
        if (state && state.question) {
            setQuestion(state.question)
        }
    }, [state])
    /** 搜索知识点 */
    const handleKnowledgeSearch = async () => {
        if (!searchedKnowledge.k_title.trim()) {
            setSearchedKnowledges([])
            return
        }
        try {
            let res = await getKnowledgesByTitle({
                appHash: userInfo.app_hash,
                title: searchedKnowledge.k_title.trim(),
            })
            if (res.data) {
                setSearchedKnowledges(res.data.getKnowledgeByTitle)
                setSearchedEmpty(!res.data.getKnowledgeByTitle.length)
            }
        } catch (error) {}
    }
    /** 合并 */
    const handlerMerge = async () => {
        if (!searchedKnowledge.k_id) return
        try {
            let res = await mergeIdentityQuestionToKnowledge({
                appHash: userInfo.app_hash,
                iqIdList: [question.questionId],
                kId: searchedKnowledge.k_id,
                questionList: [question.userQuestion],
            })
            if (
                res.data &&
                res.data.mergeIdentityQuestionToKnowledge.successfully
            ) {
                setToastToastOptions({
                    ...toastOptions,
                    isOpen: true,
                    color: 'success',
                    message: '合并成功',
                    duration: 1000,
                })
                let timer = setTimeout(() => {
                    history.go(-2)
                    clearTimeout(timer)
                }, 1000)
            }
        } catch (error) {}
    }
    return (
        <IonPage className='combine-knowledge-page'>
            <IonContent className='combine-knowledge-content'>
                <Header title='合并问题' />
                {state && (
                    <div className='page-content-box'>
                        <QuestionSection
                            value={question.userQuestion}
                            onChange={(value) =>
                                setQuestion({
                                    ...question,
                                    userQuestion: value,
                                })
                            }
                        />
                        <KnowledgeSearch
                            value={searchedKnowledge.k_title}
                            onFocus={() => setTopnListShow(false)}
                            onBlur={() =>
                                setTopnListShow(!searchedKnowledge.k_title)
                            }
                            onChange={(value) =>
                                setSearchedKnowledge({
                                    k_id: 0,
                                    k_title: value,
                                })
                            }
                        />
                        <KnowledgeList
                            dataSource={searchedKnowledges}
                            onItemClick={setSearchedKnowledge}
                        />
                        {searchedEmpty && (
                            <p className='searched-empty'>没有匹配的知识</p>
                        )}
                        {question.topNList.length > 0 && topnListShow && (
                            <TopNList
                                dataSource={question.topNList}
                                onItemClick={(item) => {
                                    setSearchedKnowledge({
                                        k_id: item.recId,
                                        k_title: item.knowledgeInfo.title,
                                    })
                                }}
                            />
                        )}
                    </div>
                )}
                <div className='footer'>
                    <IonButton
                        className='save-button'
                        disabled={!searchedKnowledge.k_id}
                        onClick={handlerMerge}
                    >
                        保存
                    </IonButton>
                </div>
                <Toast
                    {...toastOptions}
                    onClose={() =>
                        setToastToastOptions({ ...toastOptions, isOpen: false })
                    }
                />
            </IonContent>
        </IonPage>
    )
}

export default CombineKnowledge
